import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/wedding/Navbar";
import Hero from "@/components/wedding/Hero";
import Marquee from "@/components/wedding/Marquee";
import InvitationLetter from "@/components/wedding/InvitationLetter";
import Gallery from "@/components/wedding/Gallery";
import Countdown from "@/components/wedding/Countdown";
import Events from "@/components/wedding/Events";
import Venues from "@/components/wedding/Venues";
import Rsvp from "@/components/wedding/Rsvp";
import Footer from "@/components/wedding/Footer";
import MusicPlayer from "@/components/wedding/MusicPlayer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.35, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App min-h-screen overflow-x-hidden bg-obsidian text-ivory">
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <InvitationLetter />
                <Gallery />
                <Countdown />
                <Events />
                <Venues />
                <Rsvp />
            </main>
            <Footer />
            <MusicPlayer />
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#16352B",
                        border: "1px solid rgba(229,184,42,0.4)",
                        color: "#F9F7F1",
                    },
                }}
            />
        </div>
    );
}

export default App;
